import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import { WebContext } from "../../../../../Utility";
import useStyles from "./styles";
import { StyledDrawer } from "./commons";
import { useTheme } from "@material-ui/core/styles";
import logogut from "../../../../../assets/images/logout.png";
import LocalStorage from "../../../../../LocalStorage";
const MobileNavDrawer = ({
  showDrawer = false,
  setShowDrawer = () => {},
  contentArr = [],
  handleLogoutClick = () => {},
  widgetList = [],
  loginItem = [],
}) => {
  let user = LocalStorage.getUser();

  let { username = "" } = user || {};
  const classes = useStyles();
  const theme = useTheme();
  const { isLoggedIn = false } = useContext(WebContext);

  const [showLogin, setShowLogin] = useState(false);
  const [expandedDropdowns, setExpandedDropdowns] = useState({});

  let [{ component: LoginComponent = null } = {}] = widgetList.filter(
    (widget) => widget.id == "loginModal"
  );

  const toggleDropdown = (itemId) => {
    setExpandedDropdowns((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };
  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.toUpperCase();
  };
  const renderNavItem = (item, index) => {
    if (!item) return null;

    if (item.dropdown && item.clickItem && Array.isArray(item.clickItem)) {
      const isExpanded = expandedDropdowns[item.id || index];

      return (
        <React.Fragment key={`dropdown-${index}`}>
          <Box className={classes.navContentContainer}>
            <div
              onClick={() => toggleDropdown(item.id || index)}
              className={classes.contentTextSideNavbar}
              style={{
                color: theme?.agentTheme?.card?.foreground,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 0",
              }}
            >
              <span>{(item.label || item.name || "").toUpperCase()}</span>
              {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
          </Box>

          {isExpanded &&
            item.clickItem.map((subItem, subIndex) => (
              <Box
                key={`sub-${index}-${subIndex}`}
                className={classes.navContentContainer}
              >
                <NavLink
                  to={
                    typeof subItem.link === "string"
                      ? subItem.link
                      : subItem.link?.pathname || "/"
                  }
                  className={classes.contentTextSideNavbar}
                  style={{
                    color: theme?.agentTheme?.card?.foreground,
                    textDecoration: "none",
                    display: "block",
                    padding: "12px 0",
                    paddingLeft: "20px",
                  }}
                >
                  {(subItem.label || subItem.name || "").toUpperCase()}
                </NavLink>
              </Box>
            ))}
        </React.Fragment>
      );
    }

    if (item.link) {
      return (
        <Box key={index} className={classes.navContentContainer}>
          <NavLink
            to={
              typeof item.link === "string"
                ? item.link
                : item.link?.pathname || "/"
            }
            className={classes.contentTextSideNavbar}
            style={{
              color: theme?.agentTheme?.card?.foreground,
              textDecoration: "none",
              display: "block",
              padding: "12px 0",
            }}
          >
            {(item.label || item.name || "").toUpperCase()}
          </NavLink>
        </Box>
      );
    }

    return (
      <Box key={index} className={classes.navContentContainer}>
        <span
          className={classes.contentTextSideNavbar}
          style={{
            color: theme?.agentTheme?.card?.foreground,
            display: "block",
            padding: "12px 0",
          }}
        >
          {(item.label || item.name || "").toUpperCase()}
        </span>
      </Box>
    );
  };

  const renderLoginItems = () => {
    if (!isLoggedIn || !loginItem || loginItem.length === 0) return null;

    return loginItem
      .filter((item) => item.id !== "logout")
      .map((item, index) => (
        <Box key={`login-${index}`} className={classes.navContentContainer}>
          <NavLink
            to={item.link || "/"}
            className={classes.contentTextSideNavbar}
            style={{
              color: theme?.agentTheme?.card?.foreground,
              textDecoration: "none",
              display: "block",
              padding: "12px 0",
            }}
          >
            {(item.label || "").toUpperCase()}
          </NavLink>
        </Box>
      ));
  };

  const renderLogoutButton = () => {
    if (!isLoggedIn) return null;

    const logoutItemFromProp = loginItem.find((item) => item.id === "logout");

    return (
      <Box>
        <Box className={classes.navContentContainer}>
          <a
            onClick={handleLogoutClick}
            className={classes.contentTextSideNavbar}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: theme?.agentTheme?.card?.foreground,
              padding: "12px 0",
              textTransform: "none",
            }}
          >
            <span
              style={{
                display: "inline-block",
                height: 20,
                width: 20,
                WebkitMaskImage: `url(${logogut})`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                WebkitMaskSize: "contain",
                maskImage: `url(${logogut})`,
                maskRepeat: "no-repeat",
                maskPosition: "center",
                maskSize: "contain",
                backgroundColor: theme?.agentTheme?.primary?.main,
                marginRight: 9,
              }}
            />
            {logoutItemFromProp?.label || "Logout"}
          </a>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <StyledDrawer
        anchor="left"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
      >
        <Box
          className={classes.mobileNavDrawer}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            display="flex"
            width="100%"
            justifyContent="flex-start"
            style={{ padding: "20px 20px 0 20px" }}
          >
            <IconButton
              className={classes.closeBtn}
              onClick={() => setShowDrawer(false)}
              style={{ padding: 0 }}
            >
              <CloseIcon
                style={{
                  color: theme?.agentTheme?.background?.foreground,
                  fontSize: "24px",
                }}
              />
            </IconButton>
          </Box>
          {isLoggedIn && (
            <Box className={`${classes.loginButtonStyle}`}>
              <Typography
                variant="body1"
                noWrap={true}
                className={`${classes.navBarText}`}
              >{`HI, ${capitalizeFirstLetter(username)}`}</Typography>
            </Box>
          )}

          <Box style={{ flex: 1, padding: "0" }}>
            {contentArr
              .filter((item) => item.isShow !== false)
              .map((item, index) => renderNavItem(item, index))}

            {renderLoginItems()}

            {!isLoggedIn && (
              <Box style={{ marginTop: "20px" }}>
                <Button
                  style={{
                    borderColor: theme?.agentTheme?.background?.foreground,
                    color: theme?.agentTheme?.background?.foreground,
                    width: "130px",
                    height: "50px",
                    marginLeft: "1.2rem",
                    backgroundColor: "transparent",
                  }}
                  variant="outlined"
                  onClick={() => setShowLogin(true)}
                >
                  Login
                </Button>
              </Box>
            )}
            {isLoggedIn && renderLogoutButton()}
          </Box>
        </Box>
      </StyledDrawer>

      {showLogin && LoginComponent && (
        <LoginComponent onClose={() => setShowLogin(false)} />
      )}
    </>
  );
};

export default MobileNavDrawer;
